/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Alert, Grid2, Slide, Snackbar} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AllInboxOutlined,
    BadgeOutlined,
    CampaignOutlined,
    LocalOfferOutlined,
    LocalShippingOutlined,
    Notifications,
    ShoppingCartCheckout,
    StorefrontOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {useEscucharNotificacion} from "../Modulo_Notificaciones/Hooks/useEscucharNotificacion";
import {useGetToken} from "../Modulo_Notificaciones/Hooks/useGetToken";
import {usuarioContext} from "../App";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {agregarItemArrayDoc} from "../Servicios/BD/agregarItemArrayDoc";
import Seccion_Adminstradores from "./Secciones/Seccion_Adminstradores";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Sub_Categorias from "./Secciones/Seccion_Sub_Categorias";
import Seccion_Productos from "./Secciones/Seccion_Productos";
import Seccion_Categorias from "./Secciones/Seccion_Categorias";
import Seccion_Rutas from "./Secciones/Seccion_Rutas";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;



    return (
        <Grid2
            container
            size={12}
        >



            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={() => setOpen(false)}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                TransitionComponent={Slide}
                //action={action}
                role={'alert'}
                disableWindowBlurListener={true}

            >
                <Alert
                    icon={<Notifications fontSize="inherit"/>}
                    onClose={() => setOpen(false)}
                    severity={'secondary'}
                    variant={'filled'}
                    sx={{width: '100%'}}
                >
                    {'Notificaciones Encendidas'}
                </Alert>
            </Snackbar>

        </Grid2>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Pedidos',
        icono: ShoppingCartCheckout,
        camino: '/Pedidos',
        categoria: 'Pedidos',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Anuncios',
        icono: CampaignOutlined,
        camino: '/Anuncios',
        categoria: 'Pagina',
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Productos',
        icono: AllInboxOutlined,
        camino: '/Productos',
        categoria: 'Pagina',
        Componente: <Seccion_Productos/>
    },
    {
        nombre: 'Categorias',
        icono: StorefrontOutlined,
        camino: '/Categorias',
        categoria: 'Pagina',
        Componente: <Seccion_Categorias/>
    },
    {
        nombre: 'Sub Categorias',
        icono: LocalOfferOutlined,
        camino: '/SubCategorias',
        categoria: 'Pagina',
        Componente: <Seccion_Sub_Categorias/>
    },
    {
        nombre: 'Administradores',
        icono: BadgeOutlined,
        camino: '/Administradores',
        categoria: 'Accesos',
        Componente: <Seccion_Adminstradores/>
    },
    {
        nombre: 'Rutas',
        icono: LocalShippingOutlined,
        camino: '/Rutas',
        categoria: 'Pagina',
        Componente: <Seccion_Rutas/>
    }


]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}